import { render, staticRenderFns } from "./ExtModules.vue?vue&type=template&id=0ea1acf4&scoped=true"
import script from "./ExtModules.vue?vue&type=script&lang=js"
export * from "./ExtModules.vue?vue&type=script&lang=js"
import style0 from "./ExtModules.vue?vue&type=style&index=0&id=0ea1acf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1acf4",
  null
  
)

export default component.exports